/* eslint-disable @typescript-eslint/no-namespace */
const debug = require('./debug');
namespace Simple {
    import ClickEvent = JQuery.ClickEvent;
    import SubmitEvent = JQuery.SubmitEvent;

    class SimpleAuth {
        public LoginModal: JQuery;
        public SignInForm: JQuery;
        public ResetPass: JQuery;
        public RegisterForm: JQuery;
        public RegisterNotForm: JQuery;
        public FadeInDuration = 500;
        public ChangeDuration = 3000;
        public IsReferralLink = false;
        public n: string;
        public OnLogin: Function;
        readonly log: Function;


        constructor(d?: boolean, n?: string, name?: string) {
            this.n = n ?? '';
            if (name) name = 'Auth.' + name;
            else name = 'Auth';
            const Logger = debug(name);
            Logger.enabled = d || false;
            Logger.log = console.info;

            this.log = Logger;
            this.log('Init:%o', d);
            this.Find();
        }

        private static ChangeVisibility(target: string, isVisible: boolean) {
            isVisible ? $(target).css('visibility', 'visible')
                : $(target).css('visibility', 'hidden');
        }

        public Check() {
            const self = this;
            const email = this.LoginModal.find('.loginModal-signIn-login' + self.n).val();
            const pass = this.LoginModal.find('.loginModal-signIn-password' + self.n).val();
            const rememberMe = this.LoginModal.find('.loginModal-signIn-remember' + self.n).is(':checked');
            const token = this.LoginModal.find('input[name="__RequestVerificationToken"]').val();

            this.ShowHideLoader(true);
            if (this.isValidEmail(email)) {
                $.post('/Account/Login', {
                    Email: email,
                    Password: pass,
                    RememberMe: rememberMe,
                    '__RequestVerificationToken': token
                }, function (data) {
                    self.log('post:/Account/Login, %j', data);
                    self.LoginModal.find('.loginModal-error-wrongEmail' + self.n).fadeOut(self.FadeInDuration);
                    self.ValidateForm(data)
                }).catch((tt, u, v) => {
                    self.log('Error(/Account/Login) => (%j, %j)', u, v)
                    self.ShowHideLoader(false);
                }).fail(err => {
                    self.log('Error(/Account/Login) => %j', err);
                    self.ShowHideLoader(false);
                });
            } else {
                self.LoginModal.find('.loginModal-error-wrongPass' + self.n).fadeOut(self.FadeInDuration,
                    function () {
                        self.LoginModal.find('.loginModal-error-wrongEmail' + self.n).fadeOut(self.FadeInDuration,
                            function () {
                                self.LoginModal.find('.loginModal-error-wrongEmail' + self.n).fadeIn(self.FadeInDuration);
                            });
                    });
                self.LoginModal.find('.loginModal-info-id' + self.n).hide();
                self.ShowHideLoader(false);
            }
        }

        public Find() {
            const self = this;
            const n = self.n;
            this.log('Find');
            this.LoginModal = $('#login-modal' + n);
            this.SignInForm = $('.loginModal-signIn-form' + n);
            this.ResetPass = $('.loginModal-resetPass-form' + n);
            this.RegisterForm = $('.loginModal-register-form' + n);
            this.RegisterNotForm = $('#registerNotForm' + n);

            self.log(this.RegisterForm);

            this.SignInForm.off('submit').on('submit', function (e) {
                e.preventDefault();
                self.Check();
            });
            this.RegisterForm.off('submit').on('submit', function (e) {
                e.preventDefault();
                self.Register();
            });

            this.LoginModal.off('hidden.bs.modal').on('hidden.bs.modal', function () {
                self.OnHide();
            });
            this.LoginModal.find('.loginModal-forgotPassword').off('click').on('click', (e: ClickEvent) => {
                self.OnForgotPassword(e);
            });
            this.LoginModal.find('.loginModal-link-register-signIn').off('click').on('click', (e: ClickEvent) => {
                self.OnSignIn(e);
            });
            this.ResetPass.find('.loginModal-link-signIn' + n).off('click').on('click', (e: ClickEvent) => {
                self.OnSignIn(e);
            });
            this.LoginModal.find('.loginModal-link-signUp' + n).off('click').on('click', (e: ClickEvent) => {
                self.OnSignUp(e);
            });
            this.ResetPass.on('submit', e => {
                self.FogotPass(e)
            })
            this.LoginModal.on('keypress', e => {
                const submit = $('.loginModal-btn');
                if (e.keyCode == 13 && !submit.is(':disabled') && submit.is(':visible'))
                    submit.trigger('click');
            })
        }

        public FogotPass(e: SubmitEvent) {
            const self = this;
            $('.root-preloader').show();
            this.log('FogotPass:%j', e);
            e.preventDefault();
            const ResetPass: any = this.LoginModal.find('.loginModal-resetPass-form');
            const Token = this.LoginModal.find('input[name="__RequestVerificationToken"]').val();
            const Email = this.ResetPass.find('.loginModal-resetPass-login').val();

            $.post('/Account/ForgotPassword', { '__RequestVerificationToken': Token, 'Email': Email }, function (data) {
                self.log('post:/Account/ForgotPassword => %j', data);
                if (data.Error) {
                    ResetPass.find('.loginModal-error-noUser').show();
                    ResetPass.find('.loginModal-success-emailSent').hide();
                } else {
                    ResetPass.find('.loginModal-error-noUser').hide();
                    ResetPass.find('.loginModal-success-emailSent').show();
                    setTimeout(function () {
                        ResetPass.modal('hide');

                    }, self.ChangeDuration);
                }
                $('.root-preloader').hide();
            }).catch((tt, u, v) => {
                self.log('Error(/Account/ForgotPassword) => (%j, %j)', u, v)
            }).fail(err => {
                self.log('Error(/Account/ForgotPassword) => %j', err);
            });
        }

        //#region action on send Invitation Email
        protected isParentReferentAssignCodeExist(id) {
            let res = '';
            $.ajax({
                type: 'POST',
                url: '/MultipleNodeSelection/IsParentAssignInvitationLinksAvalible',
                data: { id: id },
                dataType: 'json',
                async: false,
                crossDomain: true,
                success: function (result) {
                    res = result;
                },
                error: function () {
                    alert('failed to send Invitation Id');
                }
            });
            return res;
        }
        //#endregion

        public isValidEmail(email): boolean {
            this.log('isValidEmail:%j', email);
            const pattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(email);
        }

        public isValidPassword(pass): boolean {
            this.log('isValidPass:%j', pass);
            const digit = /\d/;
            const up = /[A-Z]/;
            const down = /[a-z]/;
            const sp = /[\W]/;
            return digit.test(pass) && up.test(pass) && down.test(pass) && sp.test(pass);
        }

        protected OnForgotPassword(e: ClickEvent) {
            this.log('OnForgotPassword:%j', e);
            e.preventDefault();
            this.SignInForm.hide();
            this.RegisterForm.hide();
            this.ResetPass.show();
        }

        protected OnHide() {
            this.log('OnHide');
            this.LoginModal.find('.errorText').hide();
            this.LoginModal.find('.success').hide();
            this.SignInForm.show();
            this.ResetPass.hide();
            this.RegisterForm.hide();
            this.RegisterNotForm.hide();
            this.ResetFormState();
            this.ShowHideLoader(false);
        }

        protected OnSignIn(e: ClickEvent) {
            this.log('OnSignIn:%j', e);
            e.preventDefault();
            this.SignInForm.show();
            this.ResetPass.hide();
            this.RegisterForm.hide();
            this.RegisterNotForm.hide();
        }

        protected OnSignUp(e: ClickEvent) {
            this.log('OnSignUp:%j', e);
            e.preventDefault();
            this.SignInForm.hide();
            this.ResetPass.hide();
            this.RegisterForm.find('.register-show').hide();
            this.RegisterForm.find('.create-show').show();
            this.RegisterForm.show();
        }

        public RecaptchaKey(callback) {
            this.log('RecaptchaKey:%j', callback)
            window['grecaptcha'].ready(function () {
                window['grecaptcha'].execute(window['grecaptcha'].key, { action: 'test' }).then(function (token) {
                    //document.getElementById('captcha').value = token;
                    window['grecaptcha'].token = token
                    callback(token);
                });
            });
        }

        public Register() {
            const self = this;
            self.log('Register');
            const regFormSubmit = self.RegisterForm.find('.loginModal-btn-register' + self.n);
            regFormSubmit.attr('disabled', 'disabled');
            this.RegisterForm.find('.loginModal-register-form .errorText').hide();

            const params = (new URL(window.document.location as any)).searchParams;
            const parentCode = params.get('id');

            self.RecaptchaKey(key => {
                const dd = {
                    IsMembershipUser: false,
                    FirstName: self.RegisterForm.find('input[name="FirstName"]').val() as string,
                    LastName: self.RegisterForm.find('input[name="LastName"]').val() as string,
                    Email: self.RegisterForm.find('input[name="Email"]').val() as string,
                    Password: self.RegisterForm.find('input[name="Password"]').val() as string,
                    ConfirmPassword: self.RegisterForm.find('input[name="ConfirmPassword"]').val() as string,
                    promotionCode: self.RegisterForm.find('input[name="promotionCode"]').val() as string,
                    ParentAssignInvitationLinkId: parentCode,
                    IsReferralLink: true,
                    token: key
                };
                const successText = self.RegisterForm.find('.success');
                const errorText = self.RegisterForm.find('.errorText');
                if (dd.FirstName.length === 0) {
                    errorText.slideUp(self.FadeInDuration).html('Please enter your First Name').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.FirstName.length < 3) {
                    errorText.slideUp(self.FadeInDuration).slideUp(self.FadeInDuration).html('Your First Name must be at least 3 characters').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.LastName.length === 0) {
                    errorText.slideUp(self.FadeInDuration).html('Please enter your Last Name').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.LastName.length < 3) {
                    errorText.slideUp(self.FadeInDuration).html('Your Last Name must be at least 3 characters').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.Email.length === 0) {
                    errorText.slideUp(self.FadeInDuration).html('Please enter your Email').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (!self.isValidEmail(dd.Email)) {
                    errorText.slideUp(self.FadeInDuration).html('Please enter valid Email').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.Password !== dd.ConfirmPassword) {
                    errorText.slideUp(self.FadeInDuration).html('Password do not match').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.Password.length < 8) {
                    errorText.slideUp(self.FadeInDuration).html('Passwords must have at least:<br>8 characters, 1 Upper case letter,<br>1 number, and 1 special character').slideDown(500);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }

                if (!$('.loginModal-personalData-input' + self.n).is(':checked')) {
                    errorText.slideUp(self.FadeInDuration).html('Please confirm Privacy Policy').slideDown(self.FadeInDuration);
                    regFormSubmit.removeAttr('disabled');
                    return;
                }
                if (dd.ParentAssignInvitationLinkId !== null) {
                    if (!self.isParentReferentAssignCodeExist(dd.ParentAssignInvitationLinkId)) {
                        $('.loginModal-register-form .errorText').slideUp(500).html('This Assigned ID couldnt be used').slideDown(500);
                        $('.loginModal-btn-register').removeAttr('disabled');
                        return;
                    }
                }

                $('.root-preloader').show();

                $.post('/Account/Register', dd, function (data) {
                    self.log('post:/Account/Register => %j', data);
                    if (data.Succeeded) {
                        if (data.IsLogIn) {
                            (window.location as any) = '/';
                            return;
                        }
                        errorText.slideUp(self.FadeInDuration)
                        successText.slideUp(self.FadeInDuration).html('We send email with confirmation! Please Confirm!').slideDown(self.FadeInDuration);
                        setTimeout(function () {
                            if (window.location.href.indexOf('/Account/Register') > 0) {
                                (window.location.href as any) = '/';
                            }
                            else {
                                self.SignInForm.show();
                                self.ResetPass.hide();
                                self.RegisterForm.hide();
                                successText.hide();
                                regFormSubmit.removeAttr('disabled');
                                $('.root-preloader').hide();
                            }
                        },
                            self.ChangeDuration);
                        return;
                    }
                    $('.root-preloader').hide();
                    errorText.slideUp(self.FadeInDuration).html('');
                    // data.Errors.forEach(err => {
                    //     errorText.html(errorText.html() + err.Description + '</br>')
                    // });
                    if (data.Errors.length) {
                        if (data.Errors[0].Code == 'DuplicateUserName' || data.Errors[0].Code == 'PromoCode') {
                            errorText.html(data.Errors[0].Description);
                        } else
                            errorText.html('Passwords must have at least:<br>8 characters, 1 Upper case letter,<br>1 number, and 1 special character');
                    }
                    errorText.slideDown(self.FadeInDuration);
                    regFormSubmit.removeAttr('disabled');

                }).catch((tt, u, v) => {
                    self.log('Error(/Account/Register) => (%j, %j)', u, v)
                    regFormSubmit.removeAttr('disabled');
                }).fail(err => {
                    self.log('Error(/Account/Register) => %j', err);
                    regFormSubmit.removeAttr('disabled');
                });
            });
        }

        public ResetFormState() {
            this.log('ResetFormState');
            this.LoginModal.find('#enterPassword' + this.n).hide();
            this.LoginModal.find('#emailCheck' + this.n).show();
            this.LoginModal.find('.loginModal-error-wrongEmail' + this.n).hide();
            this.LoginModal.find('.loginModal-error-wrongPass' + this.n).hide();
            this.LoginModal.find('.loginModal-info-id' + this.n).show();
            this.LoginModal.find('.loginModal-error-signIn' + this.n).hide();
            //this.LoginModal.find('.loginModal-signIn-form')[0].reset();
            this.LoginModal.find('#passInfo' + this.n).show();
        }

        protected ShowHideLoader(b: boolean) {
            this.log('ShowHideLoader:%o', b);
            SimpleAuth.ChangeVisibility('.loginModal-preloader', b);
        }

        private ValidateForm(data) {
            this.log('ValidateForm:%j', data);
            const self = this;
            if (data.error) {
                this.LoginModal.find('.loginModal-error-wrongEmail' + self.n).fadeOut(this.FadeInDuration,
                    function () {
                        let msg;
                        if (data.type == 201)
                            msg = `<strong>Account Activation Required</strong><br>
                                Thank you for registering and confirming your email. Before you can sign in, your account needs to be activated by a manager.<br>
                                Please notify your manager to change your status from inactive to active. This action is necessary for licensing and access to your account.<br>
                                If you have any questions, feel free to reach out to our support team.`;
                        else
                            msg = data.message
                        $('.loginModal-error-wrongEmail' + self.n).html(msg);
                        $('.loginModal-error-wrongEmail' + self.n).fadeIn(self.FadeInDuration);
                    });
                this.ShowHideLoader(false);
            } else {
                if (this.OnLogin) {
                    this.OnLogin();
                } else
                    switch (window.location.pathname) {
                        case '/Business':
                            window.location.href = '/Business';
                            break;
                        default:
                            window.location.href = '/';
                            break;
                    }
            }
        }
    }

    class Simple {
        public static Auth = SimpleAuth;
        public auth: SimpleAuth;
        public log: Function;
        public name: string;
        public static Profile: any;
        public $: any | JQueryStatic;
        public window: Window;
        public ready: boolean;

        constructor(name?: string, debug?: boolean) {
            const self = this;
            if (debug == undefined) debug = true;
            if (name == undefined) name = 'App';
            this.log = this.createLogger(name, debug);
            this.log('Init');
            self.name = name;
            self.$ = (window as any).$;
            self.window = window;
            self.ready = false;
            window['InstanceSimple'] = this;
            if (!self.ready) {
                self.ready = true;
                $(() => {
                    self.onReady();
                    $(document).on('submit', '.nosubmit', (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                    })
                });
            }
        }

        get debug(): boolean {
            return (this.log as any).enabled;
        }

        set debug(b: boolean) {
            (this.log as any).enabled = b;
        }

        get OnLogin() {
            return this.auth.OnLogin;
        }

        set OnLogin(value) {
            this.auth.OnLogin = value;
        }

        //protected collapseBack() {
        //    const self = this;

        //    self.$('.collapse-back').on('click', function (e: Event) {
        //        e.preventDefault();
        //        self.$('#mainHeaderPanel-collapsed-content').collapse('hide');
        //    })
        //    self.$(self.window.document).on('click', function (e: Event) {
        //        if (self.$(e.target).closest(self.$('#mainHeaderPanel-collapsed-content')).length <= 0) {
        //            self.$('#mainHeaderPanel-collapsed-content').collapse('hide');
        //        }
        //    });
        //}

        createLogger(name?: string, d?: boolean) {
            const logger = debug(name ?? 'Debug');
            logger.enabled = d || false;
            logger.log = console.info;
            return logger;
        }

        defaultOnLogin(_?: Function) {
            sessionStorage.removeItem('userLeadsGridViewPageSize');
            sessionStorage.removeItem('gvLeadsPoolPageSize');
            if (window.location.href.indexOf('/MultipleNodeSelection/ParentInvitationAssignApprove/') > 0)
                (window.location as any) = '/';
            else
                window.location.reload();
        }

        GetParameterByName(name: string, url = window.location.href) {
            name = name.replace(/[\[\]]/g, '\\$&');
            const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        onReady() {
            const self = this;
            this.auth = new SimpleAuth(self.debug, undefined, self.name);

            //tricks with email editor changing p to div 
            const Block = window['DevExpress'].Quill.import('blots/block');
            Block.tagName = 'div';
            window['DevExpress'].Quill.register(Block, true);

            //self.collapseBack();
            self.OnLogin = function () {
                if (window['User']) {
                    ($('#login-modal') as any).modal('hide');
                    return;
                }
                self.defaultOnLogin();
            }


            $('.showPassword i').hover((e) => {
                $(e.target).closest('.position-relative').find('.hidePassword').attr('type', 'text');
                $(e.target).removeClass('fa-eye-slash').addClass('fa-eye');
            }, () => {
                $('.hidePassword').attr('type', 'password');
                $('.showPassword i').removeClass('fa-eye').addClass('fa-eye-slash');
            });

            $(document).on('click', '.loginModal-signIn-form .loginModal-btn-submit', () => {

                this.OnLogin = function () {
                    if (window['User']) {
                        ($('#login-modal') as any).modal('hide');
                        return;
                    }
                    self.defaultOnLogin();
                }
                this.auth.Check();
            });
        }
    }

    window['Simple'] = Simple;
    module.exports = Simple;
}